import * as types from '@/store/types'

export default {
  [types.MISSION__SET_ACCURACY] (state, {accuracy, isAccuracyValid}) {
    state.accuracy = accuracy
    state.isAccuracyValid = isAccuracyValid
  },
  [types.IMG__TOGGLE_THRESHOLD] (state, {imgId, hasThreshold}) {
    state.filters[imgId].hasThreshold = hasThreshold
  },
  [types.IMG__UPDATE_THRESHOLD_VALUE] (state, {imgId, value}) {
    state.filters[imgId].thresholdValue = value
  },
  [types.IMG__UPDATE_TRANSFORMATION] (state, transformations) {
    state.imageOne.transformations = transformations.imageOne
    state.imageTwo.transformations = transformations.imageTwo
  },
  updateD (state, D) {
    state.D = D;
  },
  update_loading(state,loading){
    console.log('Loading',loading)
    state.isLoading = loading;
  },
  update_AI_accuracy(state, AIaccuaracy) {
    state.AI_Accuracy = AIaccuaracy
  },
  updateNextCandidate (state, nextCandidate) {
    state.nextCandidate = nextCandidate
  },
  UpSolved (state) {
    state.solved += 1;
  },
  UpSkipped (state) {
    state.skipped += 1;
  },
  inspected (state) {
    state.inspected += 1;
  }
}
